import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const navItems = [
  { label: 'Home', path: '/' },
  { label: 'Rooms', path: '/rooms' },
  { label: 'Suites', path: '/rooms-suite' },
  { label: 'Services', path: '/services' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'About', path: '/about' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Shop', path: '/shop' },
  { label: 'Contact', path: '/contact' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [scrolled, setScrolled] = useState(false);
  const { cartCount } = useCart();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  const isActive = (path) =>
    path === '/'
      ? location.pathname === '/'
      : location.pathname.startsWith(path);

  return (
    <header className="main-header header-style-five">
      {/* ── Header Top (same on every page) ── */}
      <div className="header-top">
        <div className="header-top-inner">
          <div className="top-left">
            <ul className="social-icon-one">
              <li>
                <a href="#" aria-label="Facebook">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="#" aria-label="Instagram">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="#" aria-label="LinkedIn">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
              <li>
                <a href="#" aria-label="Twitter">
                  <i className="fab fa-x-twitter"></i>
                </a>
              </li>
            </ul>
          </div>
          <div className="top-right">
            {/* <span>
              <i className="fas fa-envelope icon"></i> info@hoteler.com
            </span> */}
            <span>
              <i className="fas fa-location-dot icon"></i> Plot 34, Area T,
              behind Apams Casket, off PH Road, Owerri, Imo State, Nigeria
            </span>
          </div>
        </div>
      </div>

      {/* ── Header Lower ── */}
      <div className="header-lower">
        <div className="main-box">
          {/* Logo */}
          <div className="logo-box">
            <Link to="/">
              <img src="/images/logo.png" alt="Hoteler" />
            </Link>
          </div>

          {/* Desktop Nav — flat, no dropdowns */}
          <nav className="main-nav">
            <ul className="nav-list">
              {navItems.map((item) => (
                <li
                  key={item.path}
                  className={isActive(item.path) ? 'active' : ''}
                >
                  <Link to={item.path}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Right icons */}
          <div className="header-icons">
            <button
              className="icon-btn"
              aria-label="Search"
              onClick={() => setSearchOpen(true)}
            >
              <i className="fas fa-magnifying-glass"></i>
            </button>
            <Link
              to="/cart"
              className="icon-btn cart-icon-btn"
              aria-label="Cart"
            >
              <i className="fas fa-cart-shopping"></i>
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </Link>
            <button
              className="icon-btn hamburger"
              aria-label="Open menu"
              onClick={() => setMobileOpen(true)}
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>
        </div>
      </div>

      {/* ── Sticky Header ── */}
      <div className={`sticky-header${scrolled ? ' visible' : ''}`}>
        <div className="sticky-inner">
          <Link to="/">
            <img src="/images/logo.png" alt="Hoteler" className="sticky-logo" />
          </Link>
          <nav className="main-nav">
            <ul className="nav-list">
              {navItems.map((item) => (
                <li
                  key={item.path}
                  className={isActive(item.path) ? 'active' : ''}
                >
                  <Link to={item.path}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>
          <div className="header-icons">
            <button className="icon-btn" onClick={() => setSearchOpen(true)}>
              <i className="fas fa-magnifying-glass"></i>
            </button>
            <Link to="/cart" className="icon-btn cart-icon-btn">
              <i className="fas fa-cart-shopping"></i>
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </Link>
            <button
              className="icon-btn hamburger"
              onClick={() => setMobileOpen(true)}
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>
        </div>
      </div>

      {/* ── Mobile Drawer ── */}
      {mobileOpen && (
        <div className="mobile-overlay" onClick={() => setMobileOpen(false)} />
      )}
      <div className={`mobile-drawer${mobileOpen ? ' open' : ''}`}>
        <div className="drawer-head">
          <Link to="/" onClick={() => setMobileOpen(false)}>
            <img
              src="/images/logo.png"
              alt="Hoteler"
              style={{ maxHeight: 40 }}
            />
          </Link>
          <button className="drawer-close" onClick={() => setMobileOpen(false)}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <ul className="drawer-nav">
          {navItems.map((item) => (
            <li key={item.path} className={isActive(item.path) ? 'active' : ''}>
              <Link to={item.path} onClick={() => setMobileOpen(false)}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className="drawer-footer">
          <p>
            <i className="fas fa-phone me-2"></i>+92 (8800) - 98670
          </p>
          {/* <p>
            <i className="fas fa-envelope me-2"></i>info@hoteler.com
          </p> */}
          <ul className="social-icon-one mt-3">
            <li>
              <a href="#">
                <i className="fab fa-facebook-f"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-x-twitter"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* ── Search Popup (centred overlay) ── */}
      {searchOpen && (
        <div className="search-overlay" onClick={() => setSearchOpen(false)}>
          <div className="search-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="search-close"
              onClick={() => setSearchOpen(false)}
            >
              <i className="fas fa-times"></i>
            </button>
            <p className="search-label">What are you looking for?</p>
            <form
              className="search-form"
              onSubmit={(e) => {
                e.preventDefault();
                setSearchOpen(false);
              }}
            >
              <input
                autoFocus
                type="search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search hotels, rooms, services…"
              />
              <button type="submit">
                <i className="fas fa-search"></i>
              </button>
            </form>
          </div>
        </div>
      )}
    </header>
  );
}
